export default __webpack_public_path__ + "static/media/probes_network.b36473c0.webp";